import type { BranchKey } from '@festina-life/api'
import { Button } from '@festina-life/ui/actions'
import { useTranslate } from '@festina-life/ui/hooks'
import { Popover, PopoverButton } from '@festina-life/ui/structure'

import { ActionsMenuPanel } from '../../../actionsPanel/ActionsMenuPanel'
import { CopyBranchForm } from './CopyBranchForm'

type Props = {
  branchKey: BranchKey
}

export const CopyBranchButton = ({ branchKey }: Props) => {
  const translate = useTranslate()

  return (
    <Popover>
      <PopoverButton as="div">
        <Button startIcon="DocumentDuplicate">
          {translate('branchDetailsPanel.tabs.manage.copyBranch')}
        </Button>
      </PopoverButton>
      <ActionsMenuPanel anchor={{ to: 'right' }} className="max-w-lg!">
        <CopyBranchForm branchKey={branchKey} />
      </ActionsMenuPanel>
    </Popover>
  )
}
